import React, { useState } from 'react';
import ClinicalButton from '../../doctor/ui/ClinicalButton';
import NursingVitalsModal from '../NursingVitalsModal';
import { hasVitalsOnConsultation } from '../../../constants/nursingStatus';

function formatVital(value, suffix = '') {
  if (value == null || value === '') return '—';
  return `${value}${suffix}`;
}

export default function NurseVitalsSection({ consultation, viewerSiteId, onUpdated, onTimelineRefresh }) {
  const [showModal, setShowModal] = useState(false);
  const hasVitals = hasVitalsOnConsultation(consultation);

  if (!consultation?.id) return null;

  return (
    <section className="nr-workspace__pane nr-panel">
      <div className="nr-panel__head">
        <div>
          <h2 className="nr-panel__title">Constantes vitales</h2>
          <p className="nr-panel__desc mb-0">
            Relevé optionnel sur ce passage — visible dans l’historique dossier adhérent.
          </p>
        </div>
        <ClinicalButton
          variant={hasVitals ? 'secondary' : 'save'}
          icon="chartBar"
          onClick={() => setShowModal(true)}
        >
          {hasVitals ? 'Modifier les constantes' : 'Saisir les constantes'}
        </ClinicalButton>
      </div>

      <div className="nr-vitals-chips">
        <div className="nr-vitals-chip">
          <span className="nr-vitals-chip__label">Poids</span>
          <span className="nr-vitals-chip__value">{formatVital(consultation.weight_kg, ' kg')}</span>
        </div>
        <div className="nr-vitals-chip">
          <span className="nr-vitals-chip__label">Taille</span>
          <span className="nr-vitals-chip__value">{formatVital(consultation.height_cm, ' cm')}</span>
        </div>
        <div className="nr-vitals-chip">
          <span className="nr-vitals-chip__label">TA</span>
          <span className="nr-vitals-chip__value">
            {formatVital(consultation.bp_systolic)} / {formatVital(consultation.bp_diastolic)} mmHg
          </span>
        </div>
        <div className="nr-vitals-chip">
          <span className="nr-vitals-chip__label">Température</span>
          <span className="nr-vitals-chip__value">{formatVital(consultation.temperature_c, ' °C')}</span>
        </div>
        <div className="nr-vitals-chip">
          <span className="nr-vitals-chip__label">FC</span>
          <span className="nr-vitals-chip__value">{formatVital(consultation.heart_rate_bpm, ' bpm')}</span>
        </div>
      </div>

      {!hasVitals ? (
        <p className="nr-panel__hint text-muted small mb-0 mt-2">
          Aucune constante enregistrée — saisissez-les uniquement si le passage le nécessite.
        </p>
      ) : null}

      <NursingVitalsModal
        show={showModal}
        onHide={() => setShowModal(false)}
        consultation={consultation}
        viewerSiteId={viewerSiteId}
        onSuccess={() => {
          if (typeof onUpdated === 'function') onUpdated();
          if (typeof onTimelineRefresh === 'function') onTimelineRefresh();
        }}
      />
    </section>
  );
}
